<script>
import { mapState } from 'vuex';
import ReportSearchBlock from '../ReportSearchBlock';

export default {
  name: 'ReportCampaign',
  mixins: [ReportSearchBlock],
  data() {
    return {
      placeholder: 'Search by Campaign',
    };
  },
  computed: {
    ...mapState('campaigns', ['campaignNames']),

    getOptions() {
      return this.campaignNames
        .filter(({ type }) => {
          if (!this.schema?.campaignType) return true;
          return this.schema.campaignType === type;
        })
        .map(({ text, value }) => {
          return {
            label: text,
            value,
          };
        });
    },
  },
};
</script>
